<template lang="pug">
.modal-card
  header.modal-card-head
    p.modal-card-title(data-qa="modal-header") 
      b(v-t="'sale.edit_membership_item_title'")
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  section.modal-card-body()
    .is-flex.is-align-items-center.is-justify-content-space-between.mb-4
      div
        p.title.is-5
          membership-package-name-view(:value="item.membershipPackage")
      div.pl-4
        p.is-size-5.has-text-right
          strong
            currency-view(:value="item.total")
        p.has-text-danger.is-size-6.has-text-right(v-if="item.total !== item.originalTotal")
          span.has-text-strikedout 
            currency-view(:value="item.originalTotal")
    
      

    .columns.is-mobile.is-multiline
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.initial_price_label')" expanded)
          b-input(v-model="item.price" readonly  expanded data-vv-as="price" name="price" numeric disabled)
          .control
            span.button.is-static 
              currency
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.final_price_label')")
          b-input(v-model.number="item.manualPrice" :disabled="item.discountType" @input="update" expanded  data-vv-as="price" name="price" numeric v-validate="'required|decimal:2|min_value:0'" :use-html5-validation="false")
          .control
            span.button.is-static 
              currency
      
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.discount_label')")
          DiscountSelect(@input="onDiscountChange" :value="item.discountType" :current-discount="item.discount" :locationId="locationId")
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.staff_label')" expanded)
          StaffSelectDropdown.brand-bordered.is-thin.px-1(
            :staffId="item.staff" 
            :locationId="locationId" 
            expanded
            @input="updateStaff" 
            :hasPreferred="false") 
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.commission_label')" expanded)
          b-input(:value="formatCurrency(item.commission)" data-vv-as="commission" name="commission" readonly expanded)
          .control
            span.button.is-static  {{item.commissionRate}}%
  footer.modal-card-foot
    .buttons
      action-button(title="actions.save" @click="save")
      button.button.is-outlined(type="button" @click="$emit('close')" ) {{$t('actions.cancel')}}
</template>
<script>
import {mapActions, mapState} from 'vuex'
import saleHelper from '../../../shared/saleHelper'
import SALE_ITEM_TYPES from '../../../constants/saleItemTypes'
import StaffSelectDropdown from '../staff/StaffSelectDropdown'
import DiscountSelect from '../discounts/DiscountSelect'
export default {
  name: 'MembershipItemEditModal',
  components: {
    StaffSelectDropdown,
    DiscountSelect
  },
  props: {
    value: {type: Object, required: true},
    locationId: {type: String, required: true},
    saleItems: {type: Array, required: true},
    customerCoupon: {type: Object, default: undefined},
    memberships: {type: Array, default: undefined}
  },
  data() {
    return {
      SALE_ITEM_TYPES,
      item: undefined,
      membershipPackage: undefined
    }
  },

  computed: {
    ...mapState('tax', ['taxesMap']),
    ...mapState('company', ['company']),
    ...mapState('location', ['locationsMap']),
    ...mapState('membershipPackages', ['membershipPackagesMap']),
    priceIncludesTax() {
      return this.company.priceIncludesTax
    }
  },
  watch: {
    customerCoupon() {
      this.update()
    }
  },
  async created() {
    this.item = Object.assign({}, this.value)
    this.membershipPackage = this.membershipPackagesMap[this.item.membershipPackage]
    await this.update()
  },
  methods: {
    ...mapActions('staff', ['fetchStaffById']),
    async update() {
      await this.recalculate()
      // this.$emit('input', this.item)
    },

    save() {
      this.$emit('input', this.item)
      this.$emit('close')
    },
    async updateStaff({staffId}) {
      this.item.staff = staffId
      this.update()
    },

    async recalculate() {
      let taxes = await this.getItemTaxRates()
      let staffMember = this.item.staff && (await this.fetchStaffById(this.item.staff))
      const {commissionRate, commissionBase} = await this.getCommissionCriteria()

      saleHelper.recalculate({
        item: this.item,
        items: this.saleItems,
        taxes,
        priceIncludesTax: this.company.priceIncludesTax,
        customerCoupon: this.customerCoupon,
        commissionRate,
        commissionBase,
        staffMember,
        memberships: this.memberships,
        rewardsEligible: await this.getRewardsEligibility()
      })
    },
    async getRewardsEligibility() {
      return this.membershipPackage.collectRewards !== false
    },
    async getCommissionCriteria() {
      let staffMember = this.item.staff && (await this.fetchStaffById(this.item.staff))
      let commissionRate = 0
      let commissionBase = 0
      if (staffMember && staffMember.commission !== undefined) {
        if (this.membershipPackage.commissionRate !== undefined) {
          commissionRate = this.membershipPackage.commissionRate
          commissionBase = this.membershipPackage.commissionType || staffMember.commission.servicesType
        } else {
          commissionRate = staffMember.commission.services || 0
          commissionBase = staffMember.commission.servicesType
        }
      }
      return {commissionRate, commissionBase}
    },
    async getItemTaxRates() {
      let taxId
      let taxDefaults = this.locationsMap[this.locationId].taxDefaults
      if (taxDefaults && taxDefaults.services) {
        taxId = taxDefaults.services
      }

      if (taxId) {
        let tax = this.taxesMap[taxId]
        let items = (tax.items && tax.items.length && tax.items.map(tId => this.taxesMap[tId])) || [tax]
        return items.map(i => {
          return {rate: i.rate, tax: i._id, name: i.name}
        })
      }
      return []
    },
    onDiscountChange(discount) {
      if (discount) {
        this.item.discountType = discount._id
        this.item.discountRate = discount.value
      } else {
        this.item.discountType = undefined
        this.item.discountRate = undefined
        this.item.manualPrice = this.item.price
      }
      this.update()
    },
    formatCurrency(value) {
      return saleHelper.formatCurrency(value, this.company.currency)
    }
  }
}
</script>
